import { BaseObjectDto } from '../../../core/business-objects/base-object/base-object.dto';
import { DtoInclude, DtoRef } from '../../../core/store/dto/dto';

export class AccountDto extends BaseObjectDto {
    @DtoInclude
    business: string;
    @DtoInclude
    title: string;
    @DtoInclude
    email: string;
    @DtoInclude
    mobile: string;
    @DtoInclude
    phone: string;
    @DtoInclude
    website: string;
    @DtoInclude
    address: string;
    @DtoInclude
    vatNumber: string;
    @DtoRef
    owner: string;
    @DtoInclude
    billingPackage: string;

    @DtoInclude
    sesFromAddress: string;
    @DtoInclude
    emailFooter: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.dto.ts